import packageJson from '../../package.json';

type AppBuildGlobals = typeof globalThis & {
  __VERSION__?: string;
  SERVER_API_URL?: string;
  ngDevMode?: boolean;
};

const appBuildGlobals = globalThis as AppBuildGlobals;
const packageVersion = (packageJson as { version?: string }).version;
const detectedBaseHref =
  (typeof document !== 'undefined' && document.querySelector('base')?.getAttribute('href')) || '/';

export const VERSION = appBuildGlobals.__VERSION__ ?? packageVersion ?? 'DEV';
export const SERVER_API_URL = appBuildGlobals.SERVER_API_URL ?? detectedBaseHref;
export const DEBUG_INFO_ENABLED = !!appBuildGlobals.ngDevMode;

